import { gql } from "@apollo/client";

export const GET_PAYMENTS = gql`
  query GetPayments($data: AdminPaymentFilter) {
    getPayments(data: $data) {
      status
      message
      totalCount
      truncated
      payments {
        id
        amount
        date
        billDate
        type
        category
        paymentMethod
        description
        attachmentUrl
        payerName
        createdAt
        updatedAt
        employeeId
        employeeName
        adminId
        adminName
        otherCategory
        dealerName
        isGstBill
        isPaymentDue
        inventoryPayments {
          id
          paymentId
          quantity
          inventoryCategoryId
          rate
          mrp
          discount
          gstPercentage
          inventoryCategory {
            id
            name
          }
        }
        settlement {
          id
          amount
          date
          paymentMethod
          reference
          attachmentUrl
          payerName
          description
          bills {
            id
            amount
            billDate
          }
        }
      }
    }
  }
`;

export const PAYMENT_METHODS = ["Cash", "Bank Transfer", "UPI", "Card", "Other"];

export const getAttachmentLink = (url) =>
  url?.startsWith("http") ? url : `https://api.barbera.in${url}`;

export const formatRupees = (value) =>
  `₹ ${Number(value || 0).toLocaleString("en-IN")}`;
